import { Component, Input, OnInit } from '@angular/core';

import { Area } from '@elotech/angular-common';
import { ListaModulosService } from '@elotech/angular-common';
import { Modulo } from '../../modulos.type';

@Component({
  selector: 'area-box-list',
  templateUrl: './area-box-list.component.html'
})
export class AreaBoxComponent implements OnInit {
  @Input() public researched: string = '';

  public areas: Area[];

  constructor(private listaModulosService: ListaModulosService) {}

  ngOnInit(): void {
    this.listaModulosService.getModulosUsuario().subscribe(area => {
      this.areas = area;
    });
  }

  moduloClick(modulo: Modulo) {
    this.listaModulosService.moduloClick(modulo);
    return false;
  }

  filtra(areas: Area[]) {
    let areasClone: Area[] = [];
    if (areas) {
      areasClone = JSON.parse(JSON.stringify(areas));
      return areasClone.filter(area => this.internalFiltraArea(area));
    }
    return areasClone;
  }

  hasAnyModulo(area: Area): boolean {
    return area.modulos.filter(modulo => modulo.podeAcessar).length > 0;
  }

  private internalFiltraArea(area: Area): boolean {
    return (
      area.modulos.filter(modulo =>
        modulo.descricao.toUpperCase().includes(this.researched.toUpperCase())
      ).length > 0
    );
  }
}
